import React from 'react';
import ReactDOM from 'react-dom/client';
import "@fontsource/public-sans/400.css";
import "@fontsource/public-sans/500.css";
import "@fontsource/public-sans/600.css";
import "@fontsource/public-sans/700.css";
import App from './App';

// Twilio can still surface its teardown message as an unhandled rejection
// while a room is being handed off (the SDK creates the promise internally).
// It is noise, never a real fault, so keep it from tripping the error overlay.
const isTwilioTeardownNoise = (value) =>
  String(value || "").includes("LocalParticipant disconnected");

window.addEventListener("unhandledrejection", (event) => {
  if (isTwilioTeardownNoise(event?.reason?.message || event?.reason)) {
    event.preventDefault();
  }
});
window.addEventListener("error", (event) => {
  if (isTwilioTeardownNoise(event?.message || event?.error?.message)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
